// extracted by mini-css-extract-plugin
module.exports = {"chart":"PieCardChart_chart__2Sr03","title":"PieCardChart_title__MN2fL"};